import { all } from 'redux-saga/effects'

import formSaga from './components/ChangePasswordForm/saga'

export default function* generalSettingsSaga() {
    yield all([formSaga()])
}
